import React, { Component } from 'react'
import * as emailjs from 'emailjs-com'
import { Button, Form, FormGroup, Label, Input } from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './Contact.css'

class Contact extends Component {
    render() {
        return (
            <div className="contact-form">
                <h1>Contact Jake</h1>
                <p>My contact form is currently under nourishment (being improved). Will be back up soon.</p>
                {/* <form><Form onSubmit={this.handleSubmit.bind(this)}>
                    <FormGroup>
                        <Label className="text-muted">Email address</Label>
                        <Input
                            style={{ fontFamily: "lato" }}
                            type="email"
                            name="email"
                            value={this.state.email}
                            className="text-primary"
                            onChange={this.handleChange.bind(this, 'email')}
                            placeholder="Enter email"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="text-muted">Name</Label>
                        <Input
                            type="text"
                            name="name"
                            value={this.state.name}
                            className="text-primary"
                            onChange={this.handleChange.bind(this, 'name')}
                            placeholder="Name"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="text-muted">Subject</Label>
                        <Input
                            type="text"
                            name="subject"
                            className="text-primary"
                            value={this.state.subject}
                            onChange={this.handleChange.bind(this, 'subject')}
                            placeholder="Subject"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="text-muted">Message</Label>
                        <Input
                            type="textarea"
                            name="message"
                            className="text-primary"
                            value={this.state.message}
                            onChange={this.handleChange.bind(this, 'message')}
                        />
                    </FormGroup>
                    <Button variant="primary" type="submit">
                        Submit
                </Button>
                </Form>
                </form> */}
            </div>
        )
    }
}

export default Contact
